import React from "react";
import TransactionsScreen from "../Containers/Transactions/TransactionsScreen";

export const TransactionsRoute = (): React.JSX.Element => <TransactionsScreen />

